import React, { useEffect, useState } from "react";
import dots from "../assets/images/dots.svg";
import { Link } from "react-router-dom";
import Nav from "./Nav";
import DropdownRight from "./DropdownRight";
import http from "../services/http";
import { SpinnerCircular } from "spinners-react";
import ReactPaginate from "react-paginate";
import { Dropdown, Space, Modal } from "antd";

const SwimFAQs = () => {
  const token = localStorage.getItem("xAuthToken");
  const [teams, setTeams] = useState([]);
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [lastPageNumber, setLastPageNumber] = useState(0);
  const [lastPage, setLastPage] = useState(0);
  const usersPerPage = 7;

  useEffect(() => {
    fetchTeams();
  }, []);

  const fetchTeams = async () => {
    setLoading(true);
    try {
      const res = await http.get(
        `api/admin/swimmerfaq/swimmerfaqs?token=${token}`
      );
      setLoading(false);
      setTeams(res.data);
      setLastPageNumber(res.data.length % usersPerPage == 0 ? usersPerPage : res.data.length % usersPerPage);
      setLastPage(Math.ceil(res.data.length / usersPerPage));
    } catch (error) {
      setLoading(false);
      console.error("Error fetching teams:", error);
    }
  };

  const changePage = ({ selected }) => {
    setPage(selected);
  };

  return (
    <div className="wrapper">
      <Nav />
      <div id="content">
        <header>
          <div className="dashboard_header">
            <div className="left-side d-flex">
              <button
                type="button"
                id="sidebarCollapse"
                className="btn btn-link bt_none"
              >
                <i className="fa fa-align-left"></i>
              </button>
              <h1>FAQs</h1>
            </div>
            <div className="user_profile">
              <DropdownRight />
            </div>
          </div>
        </header>
        <div className="analysts-wraper-head" style={{ marginBottom: "20px" }}>
          <div></div>
          <div className="map_btn">
            <Link to="/newswimfaqs" className="them_btn">
              Add FAQ
            </Link>
          </div>
        </div>
        <TeamTable
          data={teams}
          loading={loading}
          page={page}
          handlePageChange={changePage}
          lastPage={lastPage}
          lastPageNumber={lastPageNumber}
          refreshTeams={fetchTeams}
        />
      </div>
    </div>
  );
};

const TeamTable = ({
  data,
  loading,
  page,
  handlePageChange,
  lastPage,
  lastPageNumber,
  refreshTeams,
}) => {
  const usersPerPage = 7;
  const pagesVisited = page * usersPerPage;
  const pageCount = Math.ceil(data.length / usersPerPage);
  const [open, setOpen] = useState(false);
  const [confirmLoading, setConfirmLoading] = useState(false);
  const [deleteTeamId, setDeleteTeamId] = useState(0);

  const showModal = () => {
    setOpen(true);
  };

  const handleOk = async () => {
    setConfirmLoading(true);
    const token = localStorage.getItem("xAuthToken");
    try {
      await http.delete(
        `api/admin/swimmerfaq/swimmerfaqs/${deleteTeamId}?token=${token}`
      );
      setOpen(false);
      setConfirmLoading(false);
      setDeleteTeamId(0);
      refreshTeams();
    } catch (error) {
      setConfirmLoading(false);
      console.error("Error deleting team:", error);
    }
  };

  const handleCancel = () => {
    setOpen(false);
    setDeleteTeamId(0);
    setConfirmLoading(false);
  };

  const onDelete = (team) => {
    setDeleteTeamId(team.id);
    showModal();
  };

  return (
    <>
      <div className="table_vedio_upload dashbord_table team_table mb_30 over_flow mb-0">
        <Modal
          title={
            <div>
              Are you sure you want to delete <br /> This Action Can't be
              Undone.
            </div>
          }
          centered
          open={open}
          onOk={handleOk}
          confirmLoading={confirmLoading}
          onCancel={handleCancel}
        ></Modal>
        <table className="table table-borderless table-responsive-md">
          <thead>
            <tr>
              <th scope="col" className="pl_25" style={{width:200}}>
                Tags
              </th>
              <th scope="col">Questions</th>
              <th scope="col" className="" style={{width:550}}>
                Answers
              </th>
              <th scope="col" className="text-center">
                Actions
              </th>
            </tr>
          </thead>
          <tbody>
            {loading ? (
              <div className="spinner-container">
                <SpinnerCircular size="15%" />
              </div>
            ) : (
              data
                .slice(pagesVisited, pagesVisited + usersPerPage)
                .map((team, i) => (
                  <TeamRow key={team.id} team={team} onDelete={onDelete} />
                ))
            )}
          </tbody>
        </table>
      </div>
      <div className="pagination">
        <div className="paginateText">
          <p className="text-table-show">
            {" "}
            Showing{" "} 
            {data.length != 0 ? (page === pageCount - 1 ? (pagesVisited + 1 +'-'+(pagesVisited + lastPageNumber)) : (pagesVisited + 1 +'-'+(pagesVisited + usersPerPage)) ) : 0} out of{" "}
            {data.length} entries
          </p>
        </div>
        <div className="reactPaginate">
          <ReactPaginate
            previousLabel={"<<"}
            nextLabel={">>"}
            pageCount={pageCount}
            onPageChange={handlePageChange}
            containerClassName={"paginationBttns"}
            previousLinkClassName={"previousBttn"}
            nextLinkClassName={"nextBttn"}
            disabledClassName={"paginationDisabled"}
            activeClassName={"paginationActive"}
            forcePage={page}
          />
        </div>
      </div>
    </>
  );
};

const TeamRow = ({ team, onDelete }) => {
  const items = [
    {
      label: (
        <Link
          to={`/editswimfaqs/${team.id}`}
          state={{
            id: team.id,
          }}
        >
          Edit Details
        </Link>
      ),
      key: "0",
    },
    {
      label: <a onClick={() => onDelete(team)}>Delete FAQ</a>,
      key: "1",
    },
  ];

  return (
    <tr>
      <td className="pl_25">{team.tag}</td>
      <td>{team.question}</td>
      <td className="">{team.answer}</td>
      <td className="text-center">
        <Dropdown menu={{ items }} trigger={["click"]}>
          <a onClick={(e) => e.preventDefault()}>
            <Space>
              <img
                src={dots}
                className="img-fluid"
                style={{ width: 25 }}
                alt="menu icon"
              />
            </Space>
          </a>
        </Dropdown>
      </td>
    </tr>
  );
};

export default SwimFAQs;
